import React from 'react';

interface LevelToggleProps {
  value: string;
  options: readonly string[];
  disabled?: boolean;
  onChange: (value: string) => void;
}

const LevelToggle: React.FC<LevelToggleProps> = ({ value, options, disabled = false, onChange }) => {
  return (
    <div className="flex flex-wrap gap-2">
      {options.map((option) => {
        const selected = value === option;
        return (
          <button
            key={option}
            type="button"
            disabled={disabled}
            onClick={() => onChange(option)}
            className={`h-9 px-4 rounded-full text-sm font-semibold border transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed ${
              selected
                ? 'bg-[#FC480D] border-[#FC480D] text-white'
                : 'bg-white border-gray-200 text-gray-600 hover:border-gray-300'
            }`}
          >
            {option}
          </button>
        );
      })}
    </div>
  );
};

export default LevelToggle;
